import React, { useState } from "react";
import "./flight-rotations.scss";
import { t } from "i18next";
import "../../../services/scheduleService";
import AirportAutocomplete from "../../AirportAutocomplete";
import moment from "moment";
import { AUTOCOMPLETE_TYPE } from "../../../constants";
import { Divider } from "../../../common/Divider";
import downArrow from "../../../assets/images/chevron-down.png";

const FlightRotations = ({
  flightRotations,
  showMore,
  handleBack,
  handleSelection,
  handleSwap,
  setSelectedCount,
  selectedCount,
  handleProcessSchedules,
  weekData,
  handleFlightRotationsSearch,
  handleFlightsLoading,
}) => {
  const [selectedOrigin, setSelectedOrigin] = useState(null);
  const [selectedDestination, setSelectedDestination] = useState(null);

  const handleSetError = (key, text) => { };

  const clearError = (key) => { };

  const draftCallback = () => { };

  const handleSubmit = () => {
    setSelectedDestination(null);
    setSelectedOrigin(null);
    handleProcessSchedules();
  };

  return (
    <div className="flight-rotations-container">
      <div className="fr-top-section">
        <div className="top-left">
          <div className="form-group common-autocomplete">
            <div className="p-float-label input-wrapper">
              <AirportAutocomplete
                autoCompleteType={AUTOCOMPLETE_TYPE.DESTINATION}
                selectedOrigin={selectedOrigin}
                selectedDestination={selectedDestination}
                setSelectedDestination={setSelectedDestination}
                handleSetError={handleSetError}
                clearError={clearError}
                draftCallback={draftCallback}
                screen="MANAGE_BOOKING"
              />
              <label htmlFor="destination-airport">{t("COMMON.DEST")}</label>
            </div>
          </div>
          <div className="selected-week form-group">
            <label className="selected-week-label">
              {t("SCHEDULE_VISUALIZATION.SELECTED_WEEK")}:
            </label>
            <label className="week-label">
              {weekData ? `${weekData.fromDate} to ${weekData.toDate}` : "- -"}
            </label>
          </div>
        </div>
        <button
          className="primary-button"
          onClick={(e) => handleFlightRotationsSearch(selectedDestination)}
        >
          {t("COMMON.SEARCH")}
        </button>
      </div>
      <div className="fr-middle-section">
        {/* <div className="common-list-table-scroll">
          <table class="common-list-table flight-rotations-table">
            <div className="middle-header">
              <label className="outbound-label">{t("SCHEDULE_VISUALIZATION.OUTBOUND")}</label>
              <label className="inbound-label">{t("SCHEDULE_VISUALIZATION.INBOUND")}</label>
            </div>
            <tr className="table-header">
              <th className="header-cell">{t('COMMON.FLT_DATE')}</th>
              <th className="header-cell">{t('COMMON.FLT_NO')}</th>
              <th className="header-cell">{t('SCHEDULE_VISUALIZATION.LEGS')}</th>
              <th className="header-cell">{t('CHOOSE_FLT.DEP_TIME')}</th>
              <th className="header-cell">{t('CHOOSE_FLT.ARR_TIME')}</th>
              <th className="header-cell split">{t('SCHEDULE_VISUALIZATION.AIRCRAFT')}</th>
              <th className="header-cell">{t('COMMON.FLT_DATE')}</th>
              <th className="header-cell">{t('COMMON.FLT_NO')}</th>
              <th className="header-cell">{t('SCHEDULE_VISUALIZATION.LEGS')}</th>
              <th className="header-cell">{t('CHOOSE_FLT.DEP_TIME')}</th>
              <th className="header-cell">{t('CHOOSE_FLT.ARR_TIME')}</th>
              <th className="header-cell">{t('SCHEDULE_VISUALIZATION.AIRCRAFT')}</th>
            </tr>
            <Divider />
            <tbody className="table-body">
              {flightRotations && flightRotations?.length !== 0 ? (
                flightRotations?.map((flight, index) => (
                  <tr
                    className={`body-row ${index === 0 || index % 2 === 0 ? "even" : ""
                      }`}
                    id={`outbound-${flight.id}`}
                  >
                    <td className="body-cells">
                      {moment(flight.flightDate).format("DD-MMM-YYYY")}
                    </td>
                    <td className="body-cells">EY {flight.flightNumber}</td>
                    <td className="body-cells">{flight.legs}</td>
                    <td className="body-cells">{flight.depTime}</td>
                    <td className="body-cells">
                      {flight.arrivalTime} {flight.arrivalDate ? " +1" : ""}
                    </td>
                    <td className="body-cells split">{flight.aircraftType}</td>
                    {flight &&
                      flight.flightInbounds &&
                      flight.flightInbounds.map(
                        (flightInbound, outBoundindex) => (
                          <>
                            <td className="body-cells">
                              {outBoundindex === 0 && (
                                <input
                                  id={`select-inbound-${index}-${outBoundindex}`}
                                  checked={flight.checked}
                                  value={flightInbound.id}
                                  disabled={
                                    !flight.checked &&
                                    selectedCount &&
                                    selectedCount === 2
                                  }
                                  type="checkbox"
                                  name={`select-inbound-${index}-${outBoundindex}`}
                                  className="l-checkbox-only"
                                  onChange={(e) => {
                                    handleSelection(index, e);
                                    if (e.target.checked) {
                                      setSelectedCount(selectedCount + 1);
                                    } else {
                                      setSelectedCount(selectedCount - 1);
                                    }
                                  }}
                                />
                              )}
                              {moment(flightInbound.flightDate).format(
                                "DD-MMM-YYYY"
                              )}
                            </td>
                            <td className="body-cells">
                              EY {flightInbound.flightNumber}
                            </td>
                            <td className="body-cells">{flightInbound.legs}</td>
                            <td className="body-cells">
                              {flightInbound.depTime}
                            </td>
                            <td className="body-cells">
                              {flightInbound.arrivalTime}{" "}
                              {flightInbound.arrivalDate ? "  +1" : ""}
                            </td>
                            <td className="body-cells">
                              {flightInbound.aircraftType}
                            </td>
                          </>
                        )
                      )}
                  </tr>
                ))
              ) : (
                <label className="no-data-avilable">
                  {t("PERMANENT_BOOKING.NO_DATA")}
                </label>
              )}
            </tbody>
          </table>
        </div> */}
        <div className="common-list-table-scroll">
  <table className="common-list-table flight-rotations-table">
    <div className="middle-header">
      <label className="outbound-label">
        {t("SCHEDULE_VISUALIZATION.OUTBOUND")}
      </label>
      <label className="inbound-label">
        {t("SCHEDULE_VISUALIZATION.INBOUND")}
      </label>
    </div>
    <tr className="table-header">
      <th className="header-cell">{t("COMMON.FLT_DATE")}</th>
      <th className="header-cell">{t("COMMON.FLT_NO")}</th>
      <th className="header-cell">{t("SCHEDULE_VISUALIZATION.LEGS")}</th>
      <th className="header-cell">{t("CHOOSE_FLT.DEP_TIME")}</th>
      <th className="header-cell">{t("CHOOSE_FLT.ARR_TIME")}</th>
      <th className="header-cell split">{t("SCHEDULE_VISUALIZATION.AIRCRAFT")}</th>
      <th className="header-cell">{t("COMMON.FLT_DATE")}</th>
      <th className="header-cell">{t("COMMON.FLT_NO")}</th>
      <th className="header-cell">{t("SCHEDULE_VISUALIZATION.LEGS")}</th>
      <th className="header-cell">{t("CHOOSE_FLT.DEP_TIME")}</th>
      <th className="header-cell">{t("CHOOSE_FLT.ARR_TIME")}</th>
      <th className="header-cell">{t("SCHEDULE_VISUALIZATION.AIRCRAFT")}</th>
    </tr>
    <Divider />
    <tbody className="table-body">
      {flightRotations && flightRotations.length !== 0 ? (
        flightRotations.map((flight, index) => {
          const outboundLegs = flight.outboundLegs || [flight]; 
          const inboundLegs = flight.flightInbounds || [];
          const maxLegs = Math.max(outboundLegs.length, inboundLegs.length);

          return (
            <React.Fragment key={flight.id}>
              {Array.from({ length: maxLegs }).map((_, legIndex) => {
                const outbound = outboundLegs[legIndex];
                const inbound = inboundLegs[legIndex];

                return (
                  <tr
                    key={`${flight.id}-${legIndex}`}
                    className={`body-row ${index % 2 === 0 ? "even" : ""}`}
                  >
                    {/* Outbound side */}
                    {outbound ? (
                      <>
                        <td className="body-cells">
                          {moment(outbound.flightDate).format("DD-MMM-YYYY")}
                        </td>
                        <td className="body-cells">EY {outbound.flightNumber}</td>
                        <td className="body-cells">{outbound.legs}</td>
                        <td className="body-cells">{outbound.depTime}</td>
                        <td className="body-cells">
                          {outbound.arrivalTime}{" "}
                          {outbound.arrivalDate ? " +1" : ""}
                        </td>
                        <td className="body-cells split">
                          {outbound.aircraftType}
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="body-cells"></td>
                        <td className="body-cells"></td>
                        <td className="body-cells"></td>
                        <td className="body-cells"></td>
                        <td className="body-cells"></td>
                        <td className="body-cells split"></td>
                      </>
                    )}

                    {/* Inbound side */}
                    {inbound ? (
                      <>
                        <td className="body-cells">
  <input
    id={`select-inbound-${index}-${legIndex}`}
    type="checkbox"
    checked={flight.checked && legIndex === 0}
    value={inbound.id}
    disabled={
      !flight.checked &&
      selectedCount &&
      selectedCount === 2
    }
    name={`select-inbound-${index}-${legIndex}`}
    className={`l-checkbox-only ${legIndex > 0 ? "hidden-checkbox" : ""}`}
    onChange={(e) => {
      if (legIndex === 0) {
        handleSelection(index, e);
        setSelectedCount(
          e.target.checked
            ? selectedCount + 1
            : selectedCount - 1
        );
      }
    }}
  />
  {moment(inbound.flightDate).format("DD-MMM-YYYY")}
</td>

                        <td className="body-cells">EY {inbound.flightNumber}</td>
                        <td className="body-cells">{inbound.legs}</td>
                        <td className="body-cells">{inbound.depTime}</td>
                        <td className="body-cells">
                          {inbound.arrivalTime}{" "}
                          {inbound.arrivalDate ? " +1" : ""}
                        </td>
                        <td className="body-cells">{inbound.aircraftType}</td>
                      </>
                    ) : (
                      <>
                        <td className="body-cells"></td>
                        <td className="body-cells"></td>
                        <td className="body-cells"></td>
                        <td className="body-cells"></td>
                        <td className="body-cells"></td>
                        <td className="body-cells"></td>
                      </>
                    )}
                  </tr>
                );
              })}
            </React.Fragment>
          );
        })
      ) : (
        <label className="no-data-avilable">
          {t("PERMANENT_BOOKING.NO_DATA")}
        </label>
      )}
    </tbody>
  </table>
        </div>

        {showMore && (
          <label className="show-more-link" onClick={handleFlightsLoading}>
            <img src={downArrow} alt="Show more" />
            {t("ROUTING_ENQUIRY.SHOW_MORE")}
          </label>
        )}
      </div>
      <div className="fr-bottom-section">
        <button className="secondary-button" onClick={handleBack}>
          {t("COMMON.BACK_BUTTON")}
        </button>
        <button className="primary-button" onClick={handleSubmit}>
          {t("COMMON.CONT")}
        </button>
      </div>
      {flightRotations && flightRotations?.length !== 0 && <div className="float-menu">
        <div className="col-1 button-row">
          <div className="row">
            <button
              className="scroll-btn col-12"
              title="Scroll to top"
              onClick={(e) => window.scrollTo(0, 0)}
            ></button>
          </div>
          <div className="row">
            <button
              className="swap-btn col-12"
              disabled={selectedCount !== 2}
              onClick={handleSwap}
              title="Swap"
            ></button>
          </div>
          <div className="row">
            <button
              className="scroll-btn down col-12"
              title="Scroll to bottom"
              onClick={(e) => window.scrollTo(0, document.body.scrollHeight)}
            ></button>
          </div>
        </div>
      </div>}
    </div>
  );
};

export default FlightRotations;
